import { getLeafValue } from "../../helper";
import { VisitNodePassage } from "../../types";
/*
 * This visitor removes nodes from the composite tree where a specified measure has a zero or missing value.
 * It is used to exclude dimension groups (e.g., vintage years) that have no meaningful data
 * from chart visualizations. For example, filtering out vintages with zero defaults.
 * @param measureToCheck - The measure key to check for zero/missing values.
 * @returns A NodesVisitor function that removes nodes where the measure is zero or missing.
 */
const hasNonZeroValue = (measures, measureToCheck) => {
    const rawValue = measures?.[measureToCheck];
    const value = getLeafValue(rawValue);
    return value !== null && value !== undefined && value !== 0;
};
export const removeIfZeroValueVisitor = (measureToCheck) => (args) => {
    if (!measureToCheck || measureToCheck === "") {
        return;
    }
    const { visitable } = args;
    const passage = args?.context?.visitNodePassage;
    if (passage === VisitNodePassage.NodeFirst && visitable?.data) {
        const filtered = visitable.data.filter((child) => hasNonZeroValue(child.measures, measureToCheck));
        visitable.data.splice(0, visitable.data.length, ...filtered);
    }
    if (passage === VisitNodePassage.RootLast) {
        const { root } = args.context.staticData;
        const filtered = root.filter((node) => hasNonZeroValue(node.measures, measureToCheck));
        root.splice(0, root.length, ...filtered);
    }
};
